import { render, staticRenderFns } from "./CustomAccordion.vue?vue&type=template&id=806bcda8&scoped=true"
import script from "./CustomAccordion.vue?vue&type=script&lang=js"
export * from "./CustomAccordion.vue?vue&type=script&lang=js"
import style0 from "./CustomAccordion.vue?vue&type=style&index=0&id=806bcda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806bcda8",
  null
  
)

export default component.exports